document.addEventListener("DOMContentLoaded", function () {
  const content = document.getElementById("content");
  const viewMoreButton = document.getElementById("view-more");

  viewMoreButton.addEventListener("click", function () {
    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");
      viewMoreButton.textContent = "View More";
    } else {
      content.classList.add("expanded");
      viewMoreButton.textContent = "View Less";
    }
  });
});

